import Modal from './Modal';
export { Close } from './Modal';

export default Modal;
